// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"35548bab","239":"1a0d2f08","455":"5673e3a3"}[chunkId] + ".chunk.js";
};